/* GearFrost <gf-mix-match> — product-page live cart progress for the storewide mix & match offer.
 * The cart drawer / cart page versions are pure Liquid (Dawn re-renders those sections on cart
 * change); only the product page needs JS because it does not re-render when the cart updates.
 * The real discount is applied by Shopify Automatic discounts that match the tiers. */
if (!customElements.get('gf-mix-match')) {
  customElements.define(
    'gf-mix-match',
    class GfMixMatch extends HTMLElement {
      connectedCallback() {
        this.progress = this.querySelector('[data-mixmatch-progress]');
        this.t1q = parseInt(this.dataset.t1q, 10) || 2;
        this.t1d = parseInt(this.dataset.t1d, 10) || 10;
        this.t2q = parseInt(this.dataset.t2q, 10) || 3;
        this.t2d = parseInt(this.dataset.t2d, 10) || 20;

        this.render(parseInt(this.dataset.count, 10) || 0);

        // The product page doesn't re-render on cart change — refresh the count via pub/sub.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      refresh() {
        const base = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${base}.js`, { headers: { Accept: 'application/json' } })
          .then((res) => res.json())
          .then((cart) => this.render(cart.item_count || 0))
          .catch(() => {});
      }

      render(count) {
        if (!this.progress) return;
        if (count <= 0) {
          this.progress.hidden = true;
          return;
        }
        let msg;
        if (count >= this.t2q) {
          msg = `\u{1F389} You’ve unlocked ${this.t2d}% off`;
        } else if (count >= this.t1q) {
          msg = `✓ ${this.t1d}% off unlocked — add ${this.t2q - count} more for ${this.t2d}%`;
        } else {
          const need = this.t1q - count;
          msg = `\u{1F6D2} ${count} in cart — add ${need} more for ${this.t1d}% off`;
        }
        this.progress.hidden = false;
        this.progress.textContent = msg;
      }
    }
  );
}
